import React from 'react';
import View from '@bubble-ui/primitive-view';
var imgStyle = imgResizeMode => ({
  position: 'absolute',
  objectFit: imgResizeMode
});
var ItemThumbnail = _ref => {
  var {
    uri,
    imgResizeMode = 'contain'
  } = _ref;
  return /*#__PURE__*/React.createElement(View, {
    style: {
      width: 50,
      height: 50
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: uri,
    height: 50,
    width: 50,
    style: imgStyle(imgResizeMode),
    onError: event => {
      if (event.target instanceof HTMLImageElement) {
        event.target.style.display = 'none';
      }
    }
  }));
};
export { ItemThumbnail };
//# sourceMappingURL=ItemThumbnail.js.map